import { useCallback, useState } from "react";

interface UseResizableOptions {
  minWidth?: number;
  minHeight?: number;
  initialWidth?: number;
  initialHeight?: number;
}

export function useResizable({
  minWidth = 320,
  minHeight = 480,
  initialWidth = 320,
  initialHeight = 480,
}: UseResizableOptions = {}) {
  const [size, setSize] = useState({
    width: initialWidth,
    height: initialHeight,
  });

  const onMouseDown = useCallback(
    (mouseDownEvent: React.MouseEvent) => {
      const startSize = size;
      const startPosition = {
        x: mouseDownEvent.pageX,
        y: mouseDownEvent.pageY,
      };

      const onMouseMove = (e: MouseEvent) => {
        setSize({
          width: Math.max(
            startSize.width + startPosition.x - e.pageX,
            minWidth,
          ),
          height: Math.max(
            startSize.height + startPosition.y - e.pageY,
            minHeight,
          ),
        });
      };

      const onMouseUp = () => {
        document.body.removeEventListener("mousemove", onMouseMove);
      };

      document.body.addEventListener("mousemove", onMouseMove);
      document.body.addEventListener("mouseup", onMouseUp, { once: true });
    },
    [size, minWidth, minHeight],
  );

  return { ...size, onMouseDown };
}
